enum SourceCode {
    KJV = 'KJV',
    KJVi = 'KJVi',
    ASV = 'ASV',
    JPS = 'JPS',
    NWT = 'NWT',
    GLT = 'GLT',
    YLT = 'YLT',
    LXXb = 'LXXb',
    BHSox = 'BHSox',
    WLC = 'WLC',
    TransL = 'TransL',
    TransS = 'TransS',
    WLCs = 'WLCs',
    TYN = 'TYN',
    PESM = 'PESM',
    ED = 'ED',
    KIT = 'KIT',
    UBS4 = 'UBS4',
    TIS = 'TIS',
    STE = 'STE',
    SCR = 'SCR',
    BYZ = 'BYZ',
    NA27 = 'NA27',
    NA28 = 'NA28',
    TRE = 'TRE',
    WHO = 'WHO',
    Sinai = 'Sinai',
    SinaiO = 'SinaiO',
    SinaiOs = 'SinaiOs',
    Sinai3C = 'Sinai3C',
    Sinai3Cs = 'Sinai3Cs',
    AlexO = 'AlexO',
    AlexOs = 'AlexOs',
    Alex2C = 'Alex2C',
    Alex2Cs = 'Alex2Cs',
    VatB = 'VatB',
    VatBO = 'VatBO',
    VatBOs = 'VatBOs',
    VatB3C = 'VatB3C',
    VatB3Cs = 'VatB3Cs',
    TISs = 'TISs',
    STEs = 'STEs',
    SCRs = 'SCRs',
    BYZs = 'BYZs',
    NA27s = 'NA27s',
    WHOs = 'WHOs',
    PAB = 'PAB',
    LUT = 'LUT',
    SCH = 'SCH',
    SRV = 'SRV',
    LU2 = 'LU2',
    DBV = 'DBV',
    IRB = 'IRB',
    SVV = 'SVV',
    CRV = 'CRV',
    RUS = 'RUS',
    UKR = 'UKR',
    AlepMQ = 'AlepMQ',
    AlepMM = 'AlepMM',
    STRs = 'STRs',
    Rescr = 'Rescr',
    RescrO = 'RescrO',
    Rescr3C = 'Rescr3C',
    Bezae = 'Bezae',
    Bezae2C = 'Bezae2C',
    Claro = 'Claro',
    Claro4C = 'Claro4C',
    Wash = 'Wash',
    Wash1C = 'Wash1C',
    LXXr = 'LXXr',
    LXXrp = 'LXXrp',
    LXXrs = 'LXXrs',
    LXXa = 'LXXa',
    LXXe = 'LXXe',
    WSTRs = 'WSTRs',
    MLV = 'MLV',
    THOM = 'THOM',
    WLCe = 'WLCe'
}

export default SourceCode;
